'use strict';

import Player from '@vimeo/player';

const SELECTOR = '.js-header-video';

const isReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        const playerElements = element.querySelectorAll('.header__video');

        if (!playerElements.length) {
            return;
        }

        if (!isReducedMotion) {
            element.setAttribute('data-vimeo-autoplay', 'true');
        }

        const overlayElement = element.querySelector('.header__video-overlay');
        const playPauseElement = element.querySelector('.header__video-btn');
        const playPauseLabelElement = element.querySelector('.header__video-btn-text');

        const updateButtons = playing => {
            if (playing) {
                playPauseElement.classList.remove('paused');
                playPauseLabelElement.textContent = 'Pause';
            } else {
                playPauseElement.classList.add('paused');
                playPauseLabelElement.textContent = 'Play';
            }
        }

        playerElements.forEach(playerElement => {
            playerElement.player = new Player(playerElement);

            playerElement.player.on('play', () => {
                updateButtons(true);
            });

            playerElement.player.on('pause', () => {
                updateButtons(false);
            });

            playerElement.player.on('loaded', () => {
                setTimeout(() => {
                    element.classList.add('header__video--loaded');
                }, 500);

                if (isReducedMotion) {
                    playerElement.player.pause();
                }
            });
        });

        const playPause = () => {
            playerElements.forEach(playerElement => {
                playerElement.player.getPaused().then(paused => {
                    if (paused) {
                        playerElement.player.play();
                    } else {
                        playerElement.player.pause();
                    }

                    updateButtons(!paused);
                }).catch(error => {
                    console.error(error + "s");
                });
            });
        }

        if (overlayElement) {
            overlayElement.addEventListener('click', playPause);
        }

        if (playPauseElement) {
            playPauseElement.addEventListener('click', playPause);
        }
    });
}
